
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_4bsxk_13",
  "arrow-outer": "awsui_arrow-outer_xjuzf_4bsxk_17",
  "arrow-inner": "awsui_arrow-inner_xjuzf_4bsxk_17",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_4bsxk_59",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_4bsxk_59",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_4bsxk_62",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_4bsxk_62",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_4bsxk_65",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_4bsxk_65",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_4bsxk_65",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_4bsxk_65",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_4bsxk_68",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_4bsxk_68",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_4bsxk_68",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_4bsxk_68",
  "arrow-variant-info": "awsui_arrow-variant-info_xjuzf_4bsxk_72",
  "body": "awsui_body_xjuzf_4bsxk_83",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_4bsxk_119",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_4bsxk_122",
  "has-dismiss": "awsui_has-dismiss_xjuzf_4bsxk_127",
  "dismiss": "awsui_dismiss_xjuzf_4bsxk_132",
  "dismiss-control": "awsui_dismiss-control_xjuzf_4bsxk_140",
  "header-row": "awsui_header-row_xjuzf_4bsxk_144",
  "header": "awsui_header_xjuzf_4bsxk_144",
  "content": "awsui_content_xjuzf_4bsxk_173",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_4bsxk_182",
  "container": "awsui_container_xjuzf_4bsxk_190",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_4bsxk_201",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_4bsxk_201",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_4bsxk_201",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_4bsxk_206",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_4bsxk_206",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_4bsxk_206",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_4bsxk_211",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_4bsxk_211",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_4bsxk_216",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_4bsxk_216",
  "container-body": "awsui_container-body_xjuzf_4bsxk_222",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_4bsxk_262",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_4bsxk_267",
  "fixed-width": "awsui_fixed-width_xjuzf_4bsxk_270",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_4bsxk_274",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_4bsxk_281",
  "container-arrow": "awsui_container-arrow_xjuzf_4bsxk_201",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_4bsxk_331",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_4bsxk_1",
  "refresh": "awsui_refresh_xjuzf_4bsxk_385",
  "awsui-popover-settle-down": "awsui_awsui-popover-settle-down_xjuzf_4bsxk_1",
  "awsui-popover-settle-up": "awsui_awsui-popover-settle-up_xjuzf_4bsxk_1",
  "awsui-popover-settle-end": "awsui_awsui-popover-settle-end_xjuzf_4bsxk_1",
  "awsui-popover-settle-start": "awsui_awsui-popover-settle-start_xjuzf_4bsxk_1",
  "root": "awsui_root_xjuzf_4bsxk_495",
  "no-wrap": "awsui_no-wrap_xjuzf_4bsxk_527",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_4bsxk_530",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_4bsxk_530",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_4bsxk_530",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_4bsxk_552",
  "trigger": "awsui_trigger_xjuzf_4bsxk_530",
  "in-inline-token": "awsui_in-inline-token_xjuzf_4bsxk_594",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_4bsxk_642",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_4bsxk_646",
  "hover-area": "awsui_hover-area_xjuzf_4bsxk_650"
};
  